import { CSSProperties } from 'react';
import { FelaCSS, TColor, alpha, colors } from '@bridebook/ui';
import { IProps } from './index';

interface IStyles {
  humpIcon: CSSProperties;
  iconWrap: FelaCSS;
  line: FelaCSS;
  supplierIcon: CSSProperties;
  wrapper: FelaCSS;
}

const styles = ({ color }: Omit<IProps, 'color'> & { color: TColor }): IStyles => ({
  wrapper: {
    position: 'relative',
    width: '100%',
    alignItems: 'flex-end',
  },

  iconWrap: {
    position: 'relative',
    right: '16px',
    transform: 'translate(8px, 0.2%)',

    maxWidthTabletSm: {
      transform: 'translate(12px, 0.2%)',
    },
  },

  line: {
    width: '100%',
    height: '9px',
    backgroundColor: alpha(colors[color as keyof typeof colors], 60),
  },

  humpIcon: {
    bottom: -13,
    color: alpha(colors[color], 60),
    fontSize: '58px',
    lineHeight: '83px',
    position: 'absolute',
    right: 0,
  },

  supplierIcon: {
    bottom: '6px',
    color: colors.white,
    fontSize: '18px',
    position: 'absolute',
    right: '11px',
    transform: 'translateX(-50%)',
  },
});
export default styles;
